module.exports = {
      id: "icon-social-youtube-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-social-youtube",
      toString: function () {
        return this.url;
      }
    }